import { CirclePersonResponse } from "./CirclePersonResopnse";

export interface CircleTaskSchema {
  id: string;
  task_status: CircleTaskStatus;
  task_result: CirclePersonResponse | null;
  created_at: Date;
  updated_at: Date;
  error: string | null;
}

export interface CircleTaskStatusResponse {
  task_status: CircleTaskStatus;
  task_result: CirclePersonResponse | null;
}

export enum CircleTaskStatus {
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
}
